export default __webpack_public_path__ + "static/media/figuremap9.82f3b955.png";